import { createContext, useContext } from 'react';
export const ProductCurrencyContext = /*#__PURE__*/createContext(undefined);
export const useProductCurrencies = () => {
  const context = useContext(ProductCurrencyContext);
  if (context === undefined) {
    throw new Error('ProductCurrencyContext data is undefined. useProductCurrencies must be used within a ProductCurrencyProvider');
  }
  return context;
};